import { match } from 'ts-pattern';
import { TabsContent } from 'ui/tabsGroup';
import { BreakdownBanner } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownBanner';
import {
  ContentWrapper,
  MessageTypesHeader,
  PerformanceHeader,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabsContent.styles';
import { AudienceLiftHeader } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLiftHeader';
import {
  BREAKDOWN_PERFORMANCE_HEADER,
  BREAKDOWN_AUDIENCE_MESSAGE_TYPES_HEADER,
} from 'modules/intelligentInsights/constants';
import { BreakdownAudienceLift } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { BreakdownMessageTypes } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/messageType/BreakdownMessageTypes';
import { useManagementSettingsContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/ManagementSettingsContext';
import {
  getMediumHasOptimizeData,
  getMediumSettingsIsConfigured,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/breakdownUtils';
import { BreakdownMessageTypeUnconfigured } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownMessageTypeUnconfigured';
import { BreakdownTabsContentLoading } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownTabsContentLoading';
import { BreakdownExportCSV } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownExportCSV';
import { FlexSpacer } from 'ui/flexSpacer';

export const BREAKDOWN_TAB_CONTENT_TEST_ID = 'breakdown-tab-content-trigger';

export const BreakdownTabsContent = () => {
  const { selectedMedium: messageMedium, isLoading, froInsightsData } = useFroInsightsCoreContext();
  const { frmManagementSettings } = useManagementSettingsContext();

  const isMediumConfigured = getMediumSettingsIsConfigured(frmManagementSettings, messageMedium);
  const hasOptimizeData = getMediumHasOptimizeData(froInsightsData, messageMedium);
  let mediumTabContent = match({
    isMediumConfigured,
    isLoading,
    hasOptimizeData,
  })
    .with({ isLoading: true }, () => (
      <ContentWrapper>
        <BreakdownTabsContentLoading />
      </ContentWrapper>
    ))
    .with({ isMediumConfigured: false, isLoading: false }, () => (
      <BreakdownMessageTypeUnconfigured />
    ))
    .with({ isMediumConfigured: true, isLoading: false, hasOptimizeData: false }, () => (
      <BreakdownMessageTypeUnconfigured />
    ))
    .with({ isMediumConfigured: true, isLoading: false, hasOptimizeData: true }, () => (
      <ContentWrapper>
        <PerformanceHeader>{`${messageMedium} ${BREAKDOWN_PERFORMANCE_HEADER}`}</PerformanceHeader>
        <BreakdownBanner messageMedium={messageMedium} />
        <FlexSpacer gap="base" flexDirection="column" alignItems="flex-start">
          <AudienceLiftHeader />
          <BreakdownAudienceLift messageMedium={messageMedium} />
        </FlexSpacer>
        <FlexSpacer gap="base" flexDirection="column" alignItems="stretch">
          <FlexSpacer flexDirection="row" alignItems="center" justifyContent="space-between">
            <MessageTypesHeader>{BREAKDOWN_AUDIENCE_MESSAGE_TYPES_HEADER}</MessageTypesHeader>
            <BreakdownExportCSV frmSettings={frmManagementSettings} messageMedium={messageMedium} />
          </FlexSpacer>
          <BreakdownMessageTypes messageMedium={messageMedium} />
        </FlexSpacer>
      </ContentWrapper>
    ))
    .otherwise(() => <BreakdownMessageTypeUnconfigured />);
  return (
    <TabsContent
      data-test={`${messageMedium}-${BREAKDOWN_TAB_CONTENT_TEST_ID}`}
      key={messageMedium}
      value={messageMedium}
    >
      {mediumTabContent}
    </TabsContent>
  );
};
